export { default as CircleLoader } from './Circle/Circle';
export { default as DotsLoader } from './Dots/Dots';
